import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "@environments/environment";
import { Observable, Subject } from "rxjs";
import { CommonService } from "@services/common.service";
export interface ExportBody {
  id: any;
  title: any;
  type: any;
  chartID: any;
}
@Injectable({
  providedIn: "root",
})
export class CanvasService {
  private _saveListeners = new Subject<any>();
  private _saveAndExportListeners = new Subject<ExportBody>();
  private _exportListeners = new Subject<any>();
  private _publishListeners = new Subject<any>();
  private _viewListeners = new Subject<any>();
  private _editListeners = new Subject<any>();
  private _detailListeners = new Subject<any>();
  private _deleteListeners = new Subject<any>();
  private _duplicateListeners = new Subject<any>();
  private _populateListeners = new Subject<any>();
  private _exportToDashboardListeners = new Subject<any>();
  private _editAsReportListeners = new Subject<any>();
  private _editAsLayoutListeners = new Subject<any>();
  private _dirtyListeners = new Subject<any>();
  private _groupListeners = new Subject<any>();
  private _viewGroupListeners = new Subject<any>();
  private _disableListeners = new Subject<any>();
  db: IDBDatabase | null = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private commonService: CommonService
  ) {
    this.initializeIndexedDB();
  }

  private exportData!: ExportBody;
  private canvasType: any = "reports";
  private selectedChart: any = 0;

  public featureFlags: any =
    JSON.parse(sessionStorage.getItem("featureFlags")) || [];

  listen(): Observable<any> {
    return this._saveListeners.asObservable();
  }
  listenForSaveAndExport(exportBody: any): Observable<any> {
    return this._saveAndExportListeners.asObservable();
  }
  listenForExport(): Observable<any> {
    return this._exportListeners.asObservable();
  }
  listenForPublish(): Observable<any> {
    return this._publishListeners.asObservable();
  }
  listenForView(): Observable<any> {
    return this._viewListeners.asObservable();
  }
  listenForEdit(): Observable<any> {
    return this._editListeners.asObservable();
  }
  listenForDetail(): Observable<any> {
    return this._detailListeners.asObservable();
  }
  listenForGroups(): Observable<any> {
    return this._groupListeners.asObservable();
  }
  listenForViewGroups(): Observable<any> {
    return this._viewGroupListeners.asObservable();
  }
  listenForDelete(): Observable<any> {
    return this._deleteListeners.asObservable();
  }
  listenForDuplicate(): Observable<any> {
    return this._duplicateListeners.asObservable();
  }
  listenForPopulate(): Observable<any> {
    return this._populateListeners.asObservable();
  }

  listenForExportToDashboard(): Observable<any> {
    return this._exportToDashboardListeners.asObservable();
  }
  listenForEditAsReport(): Observable<any> {
    return this._editAsReportListeners.asObservable();
  }
  listenForEditAsLayout(): Observable<any> {
    return this._editAsLayoutListeners.asObservable();
  }
  listenForDirty(): Observable<any> {
    return this._dirtyListeners.asObservable();
  }
  listenForDisable(): Observable<any> {
    return this._disableListeners.asObservable();
  }

  public createReport(body: any): any {
    this.http
      .post(
        environment.enterpriseUrls.apiEndpoint + "/" + this.canvasType + "",
        body
      )
      .subscribe(
        (success: any) => {
          const id = success["data"].id;
          this.router.navigate(["/" + this.canvasType + "/edit", id]);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  public duplicateReport(body: any): any {
    this.http
      .post(
        environment.enterpriseUrls.apiEndpoint +
          "/" +
          this.canvasType +
          "/duplicate",
        body
      )
      .subscribe(
        (success: any) => {
          const id = success["data"].id;
          this.router.navigate(["/" + this.canvasType + "/edit", id]);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  public exportReportToDashboard(body: any): any {
    this.http
      .post(
        environment.enterpriseUrls.apiEndpoint +
          "/" +
          this.canvasType +
          "/clone-as-dashboard",
        body
      )
      .subscribe(
        (success: any) => {
          const id = success["data"].id;
          this.router.navigate(["/dashboards/edit", id]);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  public triggerSave() {
    this._saveListeners.next(true);
  }

  public triggerExport() {
    this._exportListeners.next(true);
  }

  public triggerPublish() {
    this._publishListeners.next(true);
  }

  public triggerView() {
    this._viewListeners.next(true);
  }

  public triggerEdit() {
    this._editListeners.next(true);
  }

  public triggerDetail() {
    this._detailListeners.next(true);
  }
  public triggerGroups() {
    this._groupListeners.next(true);
  }

  public triggerViewGroups() {
    this._viewGroupListeners.next(true);
  }

  public triggerSaveAndExport(exportBody: any) {
    this._saveAndExportListeners.next(exportBody);
  }

  public triggerDelete() {
    this._deleteListeners.next(true);
  }

  public triggerDuplicate() {
    this._duplicateListeners.next(true);
  }

  public triggerExportToDashboard() {
    this._exportToDashboardListeners.next(true);
  }

  public triggerEditAsReport() {
    this._editAsReportListeners.next(true);
  }

  public triggerEditAsLayout() {
    this._editAsLayoutListeners.next(true);
  }

  public triggerDirty() {
    this._dirtyListeners.next(true);
  }

  public triggerDisable() {
    this._disableListeners.next(true);
  }

  public triggerEnable() {
    this._disableListeners.next(false);
  }

  populateCanvas(data: any) {
    this._populateListeners.next(data);
  }

  public getCanvasWorkflows(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/workflow-groups?include=links&count=100"
    );
  }

  public getCanvasInternals(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint + "/page-type?include=links"
    );
  }

  public getCanvasReports(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint + "/reports?orderBy=name&count=500"
    );
  }

  public getRecentCanvasObjects(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/" +
        this.canvasType +
        "?count=12&page=1&orderBy=updated_at&sortDesc=true"
    );
  }

  public getFavoriteCanvasObjects(): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/" +
        this.canvasType +
        "/favorited"
    );
  }

  public getAllCanvasObjects(
    page: number,
    count: number,
    direction: boolean,
    category: any,
    searchTerm?: string
  ): any {
    if (direction) {
      return this.http.get(
        environment.enterpriseUrls.apiEndpoint +
          "/" +
          this.canvasType +
          "?category_id=" +
          category +
          "&orderBy=name&count=" +
          count +
          "&page=" +
          page +
          "&sortDesc=" +
          direction +
          "&searchTerm=" +
          searchTerm
      );
    } else {
      return this.http.get(
        environment.enterpriseUrls.apiEndpoint +
          "/" +
          this.canvasType +
          "?category_id=" +
          category +
          "&orderBy=name&count=" +
          count +
          "&page=" +
          page +
          "&searchTerm=" +
          searchTerm
      );
    }
  }

  public publishCanvases(body: any): any {
    return this.http.post(
      environment.enterpriseUrls.apiEndpoint + "/canvas/publish",
      body
    );
  }

  public getAllPublishCanvasObjects(count: number, canvasType: string): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/" +
        canvasType +
        "s?include=canvasGroups&orderBy=name&count=" +
        count
    );
  }

  public getAllScheduledCanvasObjects(count: number): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/reports?orderBy=updated_at&sortDesc=acsending&count=" +
        count
    );
  }

  public getInitialDashboardByCategory(category: any): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/dashboards?category_id=" +
        category +
        "&orderBy=name&count=1&page=1"
    );
  }

  public getRelatedDashboards(category: any): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/dashboards?category_id=" +
        category +
        "&orderBy=name&count=15&page=1"
    );
  }

  public getApplicationDashboards(category: any): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/dashboards?category_id=" +
        category +
        "&orderBy=name&count=1&page=1"
    );
  }

  public searchCanvases(searchterm: string, count: number, page: number): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/canvas-items/search?count=" +
        count +
        "&page=" +
        page +
        "&searchTerm=" +
        searchterm
    );
  }

  public searchListing(
    page: number,
    count: number,
    direction: boolean,
    category: any,
    searchTerm?: string
  ): any {
    if (!searchTerm) {
      if (direction) {
        return this.http.get(
          environment.enterpriseUrls.apiEndpoint +
            "/" +
            this.canvasType +
            "?category_id=" +
            (category || "") +
            "&orderBy=name&count=" +
            count +
            "&page=" +
            page +
            "&sortDesc=" +
            direction
        );
      } else {
        return this.http.get(
          environment.enterpriseUrls.apiEndpoint +
            "/" +
            this.canvasType +
            "?category_id=" +
            (category || "") +
            "&orderBy=name&count=" +
            count +
            "&page=" +
            page
        );
      }
    } else {
      if (direction) {
        return this.http.get(
          environment.enterpriseUrls.apiEndpoint +
            "/" +
            this.canvasType +
            "/search?category_id=" +
            (category || "") +
            "&orderBy=name&count=" +
            count +
            "&page=" +
            page +
            "&sortDesc=" +
            direction +
            "&searchTerm=" +
            searchTerm
        );
      } else {
        return this.http.get(
          environment.enterpriseUrls.apiEndpoint +
            "/" +
            this.canvasType +
            "/search?category_id=" +
            (category || "") +
            "&orderBy=name&count=" +
            count +
            "&page=" +
            page +
            "&searchTerm=" +
            searchTerm
        );
      }
    }
  }

  public getCanvas(id: number): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/" +
        this.canvasType +
        "/" +
        id +
        "?include=canvasItems,canvasCoordinates,canvasGroups,defaults"
    );
  }

  public getCanvasLight(id: string): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint + "/" + this.canvasType + "/" + id
    );
  }

  public getCanvasShell(id: number): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/" +
        this.canvasType +
        "/" +
        id +
        "?include=canvasCoordinates,canvasGroups,defaults,canvasItemsIndex,canvasItemsNonChart"
    );
  }

  public getCanvasItem(id: string): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint + "/charts/" + id
    );
  }

  public saveCanvas(id: number, body: any): any {
    // sanitize before sending
    const sanitizedBody = this.sanitizePayload(body);

    return this.http.patch(
      `${environment.enterpriseUrls.apiEndpoint}/${this.canvasType}/${id}?include=canvasItemsIndex,canvasCoordinates,canvasGroups`,
      sanitizedBody
    );
  }

  public saveDefaultDashboard(body: any): any {
    return this.http.patch(
      environment.enterpriseUrls.apiEndpoint + "/users/current",
      body
    );
  }

  getDatapointValueById(id: any, list: any) {
    if (id) {
      list.filter(function (element: any) {
        return element.id == id;
      });
    }
    return list;
  }

  public refreshCanvas(form: any, skipSanitize?: boolean): any {
    this.triggerDisable();

    let chartType = form.get("chartType")!.value;
    if (typeof chartType == "object") {
      chartType = chartType.details;
    }
    let referenceLink: any = null;
    if (form.get("drilldownLinkId")!.value) {
      referenceLink = {
        isActive: form.get("drilldownEnabled")!.value,
        type: form.get("drilldownLinkType")!.value,
        id: form.get("drilldownLinkId")!.value,
      };
    }

    let visibleDataPointIds = form.get("visibleDataPointIds")!.value;

    let appliedSeries = form.get("appliedSeries")!.value;
    let colorType = form.get("colorType")!.value;

    let groupDateRange = form.get("groupDateRange")!.value || "M";

    let dataPointAliases = form.get("dataPointAliases")!.value;

    let groupDateRangeStyles: any;
    if (
      form.get("groupdata")!.value &&
      form.get("groupdata")!.value[0] &&
      form.get("groupdata")!.value[0].dataPointId &&
      dataPointAliases &&
      groupDateRange
    ) {
      let item = this.getDatapointValueById(
        form.get("groupdata")!.value[0].dataPointId,
        dataPointAliases
      );
      groupDateRangeStyles = item[0];
    }

    if (
      chartType != "Table" &&
      chartType != "List" &&
      appliedSeries.length > 1
    ) {
      colorType = "manual";
    }
    const isDateGroupRange = form.get("isDateGroupRange")!.value;
    let formBody = {
      quantifiers: form.get("quantifierdata")!.value,
      dataPointIds: form.get("dataPointIds")!.value,
      visibleDataPointIds:
        this.commonService.generateVisualDataPoints(visibleDataPointIds),
      appliedSeries: appliedSeries,
      chartColors: this.stringifyColorsValues(
        form.get("manualChartColors")!.value
      ),
      manualChartColors: this.stringifyColorsValues(
        form.get("manualChartColors")!.value
      ),
      dynamicChartColors: form.get("dynamicChartColors")!.value,
      colorType: colorType || "manual",
      dataPointAliases: form.get("dataPointAliases")!.value,
      title: form.get("chartTitle")!.value,
      sorts: form.get("sortdata")!.value,
      groups: form.get("groupdata")!.value,
      filters: this.getmodifiers(form.get("filterdata")!.value),
      formatters: form.get("formatdata")!.value,
      chartType: chartType,
      canvasItemType: "chart",
      dataLimit: form.get("dataLimit")!.value,
      departmentScope: form.get("departmentScope")!.value,
      employeeScope: form.get("employeeScope")!.value,
      groupDateRange: groupDateRange,
      isDateGroupRange: isDateGroupRange,
      groupDateRangeStyles: groupDateRangeStyles,
      canvasId: form.get("id")!.value,
      referenceLink: referenceLink,
    };
    if (!skipSanitize) formBody = this.sanitizePayload(formBody);
    this.featureFlags = JSON.parse(sessionStorage.getItem("featureFlags"));

    if (
      (chartType && chartType.toLowerCase() == "table") ||
      (chartType && chartType.toLowerCase() == "list")
    ) {
      delete formBody["quantifiers"];
      delete formBody["groups"];
    }

    if (
      chartType &&
      chartType.toLowerCase() == "pie" &&
      appliedSeries.length > 0
    ) {
      let series = [];
      series.push(appliedSeries[0]);
      series[0].breakDownDataPointId = null;
      formBody["appliedSeries"] = series;
    }

    delete formBody["chartColors"];

    return this.http.post(
      environment.enterpriseUrls.apiEndpoint +
        "/charts/preview?include=canvasitems,filters,groups,sorts,quantifiers,visibleDataPoints,dynamicChartColors",
      formBody
    );
  }

  stringifyColorsValues(colors: any) {
    if (colors && colors != "") {
      colors.forEach((color: any) => {
        if (color && color.value) color.value = color.value.toString();
      });
      return colors;
    }
  }

  public sanitizePayload(payload: any, lightOnly: boolean = false) {
    let visibleDataPoints = [];
    let quantifiers = [];

    // --- clean root-level things ---
    if (!lightOnly) {
      if (payload.visibleDataPointIds) {
        visibleDataPoints = payload.visibleDataPointIds;
      }

      if (payload.quantifiers) {
        quantifiers = payload.quantifiers;
        const filteredQuantifiers = this.santitizeQuantifiers(
          quantifiers,
          visibleDataPoints
        );
        payload.quantifiers = filteredQuantifiers;
      }
    }

    // --- NEW: clean inside canvasItems ---
    if (Array.isArray(payload.canvasItems)) {
      payload.canvasItems = payload.canvasItems.map((item: any) => {
        const validIds = new Set(item.dataPointIds || []);

        // Clean dataPointAliases
        if (item.dataPointAliases) {
          item.dataPointAliases = item.dataPointAliases.filter(
            (alias: any, index: number, self: any[]) =>
              validIds.has(alias.id) &&
              index === self.findIndex((a) => a.id === alias.id)
          );
        }

        // Clean filters
        if (item.filters) {
          item.filters = item.filters.filter(
            (filter: any) => filter.dataPointId && validIds.has(filter.dataPointId)
          );
        }

        // Clean sorts
        if (item.sorts) {
          item.sorts = item.sorts.filter(
            (sort: any) => sort.dataPointId && validIds.has(sort.dataPointId)
          );
        }

        return item;
      });
    }

    // --- clean root-level sorts ---
    if (payload.sorts) {
      payload.sorts = payload.sorts.filter(
        (sort: any) =>
          sort.dataPointId && payload.dataPointIds?.includes(sort.dataPointId)
      );
    }

    // --- clean out empty/invalid props ---
    if (!lightOnly) {
      Object.keys(payload).forEach((key) => {
        if (
          key != "dataLimit" &&
          key != "departmentScope" &&
          key != "employeeScope"
        ) {
          if (
            typeof payload[key] == "undefined" ||
            payload[key] === "" ||
            payload[key] === null ||
            payload[key].length <= 0 ||
            (payload[key][0] &&
              payload[key][0].modifiers &&
              payload[key][0].modifiers.length <= 0)
          ) {
            delete payload[key];
          }
        }
      });
    }

    if (payload.dataPointAliases && payload.dataPointIds) {

      payload.dataPointAliases = payload.dataPointAliases.filter(

        (alias: any, index: number, self: any[]) =>

          payload.dataPointIds.includes(alias.id) &&

          index === self.findIndex((a) => a.id === alias.id)

      );
    }

    return payload;
  }

  public santitizeQuantifiers(quantifiers: any, visibleDataPoints: any) {
    let filteredQuantifiers: any = [];

    quantifiers.forEach((element: any) => {
      if (visibleDataPoints.indexOf(element.dataPointId) != -1) {
        filteredQuantifiers.push(element);
      }
    });
    return filteredQuantifiers;
  }

  public drilldown(form: any, id: any, filter: any): any {
    let chartType = "Table";

    let filters = this.getmodifiers(form.get("filterdata")!.value);

    let filtersMerged = filter;
    if (filters && filters.length >= 1) {
      filters[0].condition = "and";
      filtersMerged = filter.concat(filters);
    }
    let groupDateRange = form.get("groupDateRange")!.value;

    let referenceLink: any = null;
    if (form.get("drilldownLinkId")!.value) {
      referenceLink = {
        isActive: form.get("drilldownEnabled")!.value,
        type: form.get("drilldownLinkType")!.value,
        id: form.get("drilldownLinkId")!.value,
      };
    }

    let formBody = {
      quantifiers: form.get("quantifierdata")!.value,
      dataPointIds: form.get("dataPointIds")!.value,
      title: form.get("chartTitle")!.value,
      sorts: form.get("sortdata")!.value,
      groups: form.get("groupdata")!.value,
      filters: filtersMerged,
      formatters: form.get("formatdata")!.value,
      chartType: chartType,
      canvasItemType: "chart",
      dataPointAliases: form.get("dataPointAliases")!.value,
      isDrilldown: true,
      canvasId: form.get("id")!.value,
      visibleDataPointIds: form.get("dataPointIds")!.value,
      referenceLink: referenceLink,
      departmentScope: form.get("departmentScope")!.value,
      employeeScope: form.get("employeeScope")!.value,
      groupDateRange: groupDateRange,
      dataLimit: form.get("dataLimit")!.value,
    };

    if (chartType && chartType.toLowerCase() == "table") {
      formBody.quantifiers = [];
      formBody.groups = [];
      formBody.formatters = [];
    }
    if (chartType && chartType.toLowerCase() == "list") {
      formBody.quantifiers = [];
      formBody.groups = [];
      formBody.formatters = [];
      formBody.sorts = [];
    }

    formBody = this.sanitizePayload(formBody);
    return this.http.post(
      environment.enterpriseUrls.apiEndpoint +
        "/charts/preview?include=canvasitems,filters,groups,sorts,quantifiers&showVisible=true",
      formBody
    );
  }

  private getmodifiers(data: any) {
    let filterArray: any = [];
    if (data) {
      data.forEach((filterelement: any) => {
        let modifiers: any = [];
        if (filterelement.modifications) {
          filterelement.modifications.forEach((element: any) => {
            if (element.value) {
              modifiers.push({ id: element.id, value: element.value });
            }
          });
        }
        let filter = {
          condition: filterelement.condition,
          dataPointId: filterelement.dataPointId,
          modifiers: modifiers,
        };
        filterArray.push(filter);
      });
    }
    return filterArray;
  }

  initializeIndexedDB() {
    const request = indexedDB.open("CanvasDatabase", 1);

      request.onsuccess = (event) => {
        this.db = request.result;
        //IndexedDB opened successfully
      };

      request.onerror = () => console.error("Error opening IndexedDB.");

      request.onupgradeneeded = (event: any) => {
        const db = event.target.result;
        db.createObjectStore("canvasItems", { keyPath: "id" });
      };
  }

  public saveCanvasItems(canvasItems: any) {
    if (!this.db) {
        return console.error("Database is not initialized.");
    }

    // Sanitize the canvasItems to ensure they are serializable
    const sanitizedCanvasItems = JSON.parse(JSON.stringify(canvasItems, (key, value) => {
        if (typeof value === 'function') {
            return value.toString();
        }
        return value;
    }));

    const transaction = this.db.transaction("canvasItems", "readwrite");
    const objectStore = transaction.objectStore("canvasItems");
    
    // Override the existing data
    const request = objectStore.put({ id: "canvasItems", data: sanitizedCanvasItems });

    request.onsuccess = () => {
        console.log("Canvas items saved to IndexedDB.");
    };

    request.onerror = () => {
        console.error("Failed to save canvas items to IndexedDB.");
    };
  }

  public getCanvasItems(callback: (data: any) => void) {
    if (!this.db) {
      console.error("Database is not initialized.");
      return callback(null);
    }

    const transaction = this.db.transaction("canvasItems", "readonly");
    const objectStore = transaction.objectStore("canvasItems");
    const request = objectStore.get("canvasItems");

    request.onsuccess = (event: any) => {
      const result = event.target.result;
      callback(result ? result.data : null);
        if (!result) console.log("No canvas items found in IndexedDB.");
    };
    
    request.onerror = () => {
      console.error("Failed to retrieve canvas items from IndexedDB.");
      callback(null);
    };
  }

  public pushChartToStorage(chart: any) {
    this.getCanvasItems((canvasItems) => {
      if (!canvasItems) return console.error("Failed to retrieve canvas items for updating chart.");

      canvasItems[this.selectedChart].object.data = chart;
      this.saveCanvasItems(canvasItems);
    });
  }

  public getChartFromStorage(): any {
    if (!this.db) {
      //Database is not initialized
      return null;
    }

    const transaction = this.db.transaction("canvasItems", "readonly");
    const objectStore = transaction.objectStore("canvasItems");
    const request = objectStore.get("canvasItems");

    request.onsuccess = (event: any) => {
      const canvasItems = event.target.result ? event.target.result.data : null;
        
      if (canvasItems?.[this.selectedChart]) {
        const chart = canvasItems[this.selectedChart].object.data;
        return chart;
      } else {
        console.error("No canvas items found in IndexedDB.");
        return null;
      }
    };

    request.onerror = () => {
      console.error("Failed to retrieve canvas items from IndexedDB.");
      return null;
    };
  }

  public deleteCanvas(id: any, type: string): any {
    this.http
      .delete(
        environment.enterpriseUrls.apiEndpoint +
          "/" +
          this.canvasType +
          "/" +
          id
      )
      .subscribe(
        () => {
          setTimeout(() => this.router.navigate(["/" + type + "s"]), 1000);
        },
        () => {}
      );
  }

  public favoriteCanvas(id: number): any {
    this.http
      .post(
        environment.enterpriseUrls.apiEndpoint +
          "/" +
          this.canvasType +
          "/" +
          id +
          "/favorite",
        ""
      )
      .subscribe(() => {});
  }

  public createChart(id: number, type: string): any {
    let body = {
      canvasId: id,
      chartType: type,
      canvasItemType: "chart",
      dataPointIds: [] as any[],
      filters: [] as any[],
      data_set_id: null as any,
    };

    body = this.sanitizePayload(body);
    return this.http.post(
      environment.enterpriseUrls.apiEndpoint +
        "/charts/preview?include=canvasItems,filters,groups,sorts",
      body
    );
  }

  public deleteChart(id: number): any {
    return this.http.delete(
      environment.enterpriseUrls.apiEndpoint + "/charts/" + id
    );
  }

  setType(param: any) {
    this.canvasType = param;
  }

  setSelected(param: any) {
    this.selectedChart = param;
  }

  public getDashboardByReportId(id: number): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/" +
        this.canvasType +
        "/linked-dashboards/" +
        id
    );
  }
}
